export default __webpack_public_path__ + "static/media/Chilli.3183b96f.jpg";